import { getCountryName } from '@monoimin/utils/formatters';

import type { Locales, StrapiEstate } from '@monoimin/sb-types';

export const createMetaTitleForProperty = (
  property: StrapiEstate | undefined,
  locale: Locales
) => {
  const countryName = getCountryName(property?.country?.code, locale);

  if (countryName && property?.city?.title) {
    return `${property.title}. ${countryName}. ${property.city.title}`;
  }

  return property?.title || '';
};

export default createMetaTitleForProperty;
